export default {
  footer:
    'En continuant, j’accepte les <2>conditions générales d’utilisation</2> et <6>politiques de confidentialité</6>',
};
